/**
 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
 * @version v5.1.3
 * @link https://github.com/ten1seven/what-input
 * @license MIT
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("whatInput", [], factory);
	else if(typeof exports === 'object')
		exports["whatInput"] = factory();
	else
		root["whatInput"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function () {
	  /*
	   * bail out if there is no document or window
	   * (i.e. in a node/non-DOM environment)
	   *
	   * Return a stubbed API instead
	   */
	  if (typeof document === 'undefined' || typeof window === 'undefined') {
	    return {
	      // always return "initial" because no interaction will ever be detected
	      ask: function ask() {
	        return 'initial';
	      },

	      // always return null
	      element: function element() {
	        return null;
	      },

	      // no-op
	      ignoreKeys: function ignoreKeys() {},

	      // no-op
	      specificKeys: function specificKeys() {},

	      // no-op
	      registerOnChange: function registerOnChange() {},

	      // no-op
	      unRegisterOnChange: function unRegisterOnChange() {}
	    };
	  }

	  /*
	   * variables
	   */

	  // cache document.documentElement
	  var docElem = document.documentElement;

	  // currently focused dom element
	  var currentElement = null;

	  // last used input type
	  var currentInput = 'initial';

	  // last used input intent
	  var currentIntent = currentInput;

	  // check for sessionStorage support
	  // then check for session variables and use if available
	  try {
	    if (window.sessionStorage.getItem('what-input')) {
	      currentInput = window.sessionStorage.getItem('what-input');
	    }

	    if (window.sessionStorage.getItem('what-intent')) {
	      currentIntent = window.sessionStorage.getItem('what-intent');
	    }
	  } catch (e) {}

	  // event buffer timer
	  var eventTimer = null;

	  // form input types
	  var formInputs = ['input', 'select', 'textarea'];

	  // empty array for holding callback functions
	  var functionList = [];

	  // list of modifier keys commonly used with the mouse and
	  // can be safely ignored to prevent false keyboard detection
	  var ignoreMap = [16, // shift
	  17, // control
	  18, // alt
	  91, // Windows key / left Apple cmd
	  93 // Windows menu / right Apple cmd
	  ];

	  var specificMap = [];

	  // mapping of events to input types
	  var inputMap = {
	    keydown: 'keyboard',
	    keyup: 'keyboard',
	    mousedown: 'mouse',
	    mousemove: 'mouse',
	    MSPointerDown: 'pointer',
	    MSPointerMove: 'pointer',
	    pointerdown: 'pointer',
	    pointermove: 'pointer',
	    touchstart: 'touch'

	    // boolean: true if touch buffer is active
	  };var isBuffering = false;

	  // boolean: true if the page is being scrolled
	  var isScrolling = false;

	  // store current mouse position
	  var mousePos = {
	    x: null,
	    y: null

	    // map of IE 10 pointer events
	  };var pointerMap = {
	    2: 'touch',
	    3: 'touch', // treat pen like touch
	    4: 'mouse'

	    // check support for passive event listeners
	  };var supportsPassive = false;

	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        supportsPassive = true;
	      }
	    });

	    window.addEventListener('test', null, opts);
	  } catch (e) {}

	  /*
	   * set up
	   */

	  var setUp = function setUp() {
	    // add correct mouse wheel event mapping to `inputMap`
	    inputMap[detectWheel()] = 'mouse';

	    addListeners();
	    doUpdate('input');
	    doUpdate('intent');
	  };

	  /*
	   * events
	   */

	  var addListeners = function addListeners() {
	    // `pointermove`, `MSPointerMove`, `mousemove` and mouse wheel event binding
	    // can only demonstrate potential, but not actual, interaction
	    // and are treated separately
	    var options = supportsPassive ? { passive: true } : false;

	    // pointer events (mouse, pen, touch)
	    if (window.PointerEvent) {
	      window.addEventListener('pointerdown', setInput);
	      window.addEventListener('pointermove', setIntent);
	    } else if (window.MSPointerEvent) {
	      window.addEventListener('MSPointerDown', setInput);
	      window.addEventListener('MSPointerMove', setIntent);
	    } else {
	      // mouse events
	      window.addEventListener('mousedown', setInput);
	      window.addEventListener('mousemove', setIntent);

	      // touch events
	      if ('ontouchstart' in window) {
	        window.addEventListener('touchstart', eventBuffer, options);
	        window.addEventListener('touchend', setInput);
	      }
	    }

	    // mouse wheel
	    window.addEventListener(detectWheel(), setIntent, options);

	    // keyboard events
	    window.addEventListener('keydown', eventBuffer);
	    window.addEventListener('keyup', eventBuffer);

	    // focus events
	    window.addEventListener('focusin', setElement);
	    window.addEventListener('focusout', clearElement);
	  };

	  // checks conditions before updating new input
	  var setInput = function setInput(event) {
	    // only execute if the event buffer timer isn't running
	    if (!isBuffering) {
	      var eventKey = event.which;
	      var value = inputMap[event.type];

	      if (value === 'pointer') {
	        value = pointerType(event);
	      }

	      var ignoreMatch = !specificMap.length && ignoreMap.indexOf(eventKey) === -1;

	      var specificMatch = specificMap.length && specificMap.indexOf(eventKey) !== -1;

	      var shouldUpdate = value === 'keyboard' && eventKey && (ignoreMatch || specificMatch) || value === 'mouse' || value === 'touch';

	      if (currentInput !== value && shouldUpdate) {
	        currentInput = value;

	        try {
	          window.sessionStorage.setItem('what-input', currentInput);
	        } catch (e) {}

	        doUpdate('input');
	      }

	      if (currentIntent !== value && shouldUpdate) {
	        // preserve intent for keyboard typing in form fields
	        var activeElem = document.activeElement;
	        var notFormInput = activeElem && activeElem.nodeName && formInputs.indexOf(activeElem.nodeName.toLowerCase()) === -1;

	        if (notFormInput) {
	          currentIntent = value;

	          try {
	            window.sessionStorage.setItem('what-intent', currentIntent);
	          } catch (e) {}

	          doUpdate('intent');
	        }
	      }
	    }
	  };

	  // updates the doc and `inputTypes` array with new input
	  var doUpdate = function doUpdate(which) {
	    docElem.setAttribute('data-what' + which, which === 'input' ? currentInput : currentIntent);

	    fireFunctions(which);
	  };

	  // updates input intent for `mousemove` and `pointermove`
	  var setIntent = function setIntent(event) {
	    // test to see if `mousemove` happened relative to the screen to detect scrolling versus mousemove
	    detectScrolling(event);

	    // only execute if the event buffer timer isn't running
	    // or scrolling isn't happening
	    if (!isBuffering && !isScrolling) {
	      var value = inputMap[event.type];
	      if (value === 'pointer') {
	        value = pointerType(event);
	      }

	      if (currentIntent !== value) {
	        currentIntent = value;

	        try {
	          window.sessionStorage.setItem('what-intent', currentIntent);
	        } catch (e) {}

	        doUpdate('intent');
	      }
	    }
	  };

	  var setElement = function setElement(event) {
	    if (!event.target.nodeName) {
	      // If nodeName is undefined, clear the element
	      // This can happen if click inside an <svg> element.
	      clearElement();
	      return;
	    }

	    currentElement = event.target.nodeName.toLowerCase();
	    docElem.setAttribute('data-whatelement', currentElement);

	    if (event.target.classList && event.target.classList.length) {
	      docElem.setAttribute('data-whatclasses', event.target.classList.toString().replace(' ', ','));
	    }
	  };

	  var clearElement = function clearElement() {
	    currentElement = null;

	    docElem.removeAttribute('data-whatelement');
	    docElem.removeAttribute('data-whatclasses');
	  };

	  // buffers events that frequently also fire mouse events
	  var eventBuffer = function eventBuffer(event) {
	    // set the current input
	    setInput(event);

	    // clear the timer if it happens to be running
	    window.clearTimeout(eventTimer);

	    // set the isBuffering to `true`
	    isBuffering = true;

	    // run the timer
	    eventTimer = window.setTimeout(function () {
	      // if the timer runs out, set isBuffering back to `false`
	      isBuffering = false;
	    }, 100);
	  };

	  /*
	   * utilities
	   */

	  var pointerType = function pointerType(event) {
	    if (typeof event.pointerType === 'number') {
	      return pointerMap[event.pointerType];
	    } else {
	      // treat pen like touch
	      return event.pointerType === 'pen' ? 'touch' : event.pointerType;
	    }
	  };

	  // detect version of mouse wheel event to use
	  // via https://developer.mozilla.org/en-US/docs/Web/Events/wheel
	  var detectWheel = function detectWheel() {
	    var wheelType = void 0;

	    // Modern browsers support "wheel"
	    if ('onwheel' in document.createElement('div')) {
	      wheelType = 'wheel';
	    } else {
	      // Webkit and IE support at least "mousewheel"
	      // or assume that remaining browsers are older Firefox
	      wheelType = document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll';
	    }

	    return wheelType;
	  };

	  // runs callback functions
	  var fireFunctions = function fireFunctions(type) {
	    for (var i = 0, len = functionList.length; i < len; i++) {
	      if (functionList[i].type === type) {
	        functionList[i].fn.call(undefined, type === 'input' ? currentInput : currentIntent);
	      }
	    }
	  };

	  // finds matching element in an object
	  var objPos = function objPos(match) {
	    for (var i = 0, len = functionList.length; i < len; i++) {
	      if (functionList[i].fn === match) {
	        return i;
	      }
	    }
	  };

	  var detectScrolling = function detectScrolling(event) {
	    if (mousePos['x'] !== event.screenX || mousePos['y'] !== event.screenY) {
	      isScrolling = false;

	      mousePos['x'] = event.screenX;
	      mousePos['y'] = event.screenY;
	    } else {
	      isScrolling = true;
	    }
	  };

	  /*
	   * init
	   */

	  // don't start script unless browser cuts the mustard
	  // (also passes if polyfills are used)
	  if ('addEventListener' in window && Array.prototype.indexOf) {
	    setUp();
	  }

	  /*
	   * api
	   */

	  return {
	    // returns string: the current input type
	    // opt: 'intent'|'input'
	    // 'input' (default): returns the same value as the `data-whatinput` attribute
	    // 'intent': includes `data-whatintent` value if it's different than `data-whatinput`
	    ask: function ask(opt) {
	      return opt === 'intent' ? currentIntent : currentInput;
	    },

	    // returns string: the currently focused element or null
	    element: function element() {
	      return currentElement;
	    },

	    // overwrites ignored keys with provided array
	    ignoreKeys: function ignoreKeys(arr) {
	      ignoreMap = arr;
	    },

	    // overwrites specific char keys to update on
	    specificKeys: function specificKeys(arr) {
	      specificMap = arr;
	    },

	    // attach functions to input and intent "events"
	    // funct: function to fire on change
	    // eventType: 'input'|'intent'
	    registerOnChange: function registerOnChange(fn, eventType) {
	      functionList.push({
	        fn: fn,
	        type: eventType || 'input'
	      });
	    },

	    unRegisterOnChange: function unRegisterOnChange(fn) {
	      var position = objPos(fn);

	      if (position || position === 0) {
	        functionList.splice(position, 1);
	      }
	    }
	  };
	}();

/***/ })
/******/ ])
});
;
"use strict";document.addEventListener('DOMContentLoaded',function(){var css="";var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=document.getElementById("kanalc").dataset.colors.split(",")[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var categoryColor=_step.value;if(categoryColor.indexOf("#")!==-1){var category=categoryColor.substring(0,categoryColor.length-7);var color=categoryColor.substring(categoryColor.length-7,categoryColor.length);var acolor=".acolor-"+category;css+=".border-"+category+"{border-color:"+color+";}"+acolor+" .menu .active>a, "+acolor+" a:not(.btn), "+acolor+" .icon-search, "+".archivecolor-"+category+" .more-link{color:"+color+";}"+acolor+" a:not(.btn):hover, "+acolor+" a:not(.btn):focus, "+acolor+" .menu .active>a:hover, "+acolor+" .menu .active>a:focus, "+acolor+" .icon-search:hover, "+acolor+" .icon-search:focus, "+".archivecolor-"+category+" .more-link:hover, "+".archivecolor-"+category+" .more-link:focus{color:rgb("+_0x2rgb(color,35)+");}"+acolor+" .btn{background-color:"+color+";}"+acolor+" .btn:hover, "+acolor+" .btn:focus{background-color:rgb("+_0x2rgb(color,25)+");}"+".bgcolor-"+category+"{background-color:rgba("+_0x2rgb(color)+",0.45);}"+".diagonal-"+category+"{background:url(\"data:image/svg+xml,"+_makeSVG(color)+"\") 0px 0px/15px;}"+".bg-"+category+"{background:url(\"data:image/svg+xml,"+_makeSVG(color)+"\") 0px 0px/8px;}";}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}document.getElementById("kac-color-style").innerHTML=css;function _0x2rgb(str){var plus=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var toDec=function toDec(str,pos,plus){var val=parseInt(str.substr(pos,2),16)+plus;return val>255?255:val;};return toDec(str,1,plus)+","+toDec(str,3,plus)+","+toDec(str,5,plus);}function _makeSVG(color){return"<svg xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' "+"xmlns='http://www.w3.org/2000/svg' height='20' width='20' "+"xmlns:cc='http://creativecommons.org/ns%23' "+"xmlns:dc='http://purl.org/dc/elements/1.1/' viewBox='0 0 20 20'>"+"<g fill-rule='evenodd' transform='translate(0 -1032.4)' stroke-width='0' "+"fill='%23"+color.substring(1,color.length)+"'>"+// %23 is HTML encoding for # and strictly necessary.
"<path d='m0.000005 1034.9 2.5-2.5h-2.5z'/>"+"<path d='m0.000005 1039.9 7.5-7.5h5l-12.5 12.5z'/>"+"<path d='m0.000005 1049.9 17.5-17.5h2.5v2.5l-17.5 17.5h-2.5z'/>"+"<path d='m7.5 1052.4 12.5-12.5v5l-7.5 7.5z'/>"+"<path d='m17.5 1052.4 2.5-2.5v2.5z'/>"+"</g></svg>";}});
"use strict";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Countdown=function(){function Countdown(htmlElement){_classCallCheck(this,Countdown);this.scheduleDays=JSON.parse(htmlElement.dataset.timers);this.initialOffset=Date.parse(new Date())-htmlElement.dataset.current;this.texts=htmlElement.querySelectorAll(".kac-singlecountdown");var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=this.texts[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var tag=_step.value;tag.innerHTML=tag.innerHTML.replace(/!KANALCCOUNTDOWN/g,"<span class='kac-singlecountdown-timer'></span>");}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}this.clockIndex=0;// finde heraus, welche Countdowns bereits zu Beginn des Skripts abgelaufen sind
while(this.getTimeRemaining(this.scheduleDays[this.clockIndex])<=0){this.iterateClockIndex();}this.texts[this.clockIndex].style.display="block";this.updateTimer();var self=this;setInterval(function(){self.updateTimer();},1000);}_createClass(Countdown,[{key:"getTimeRemaining",value:function getTimeRemaining(endtime){var t=endtime-Date.parse(new Date())-this.initialOffset;return{'total':t,'days':Math.floor(t/(1000*60*60*24)),'hours':Math.floor(t/(1000*60*60)%24),'minutes':Math.floor(t/1000/60%60),'seconds':Math.floor(t/1000%60)};}},{key:"updateTimer",value:function updateTimer(){var addLeadingZero=function addLeadingZero(number){return('0'+number).slice(-2);};var _getTimeRemaining=this.getTimeRemaining(this.scheduleDays[this.clockIndex]),days=_getTimeRemaining.days,hours=_getTimeRemaining.hours,minutes=_getTimeRemaining.minutes,seconds=_getTimeRemaining.seconds,total=_getTimeRemaining.total;var timerText=void 0;if(days>0){timerText=days+(days>1?" Tage, ":" Tag, ")+hours+"h "+addLeadingZero(minutes)+"m "+addLeadingZero(seconds)+"s";}else if(hours>0){timerText=hours+"h "+addLeadingZero(minutes)+"m "+addLeadingZero(seconds)+"s";}else if(minutes>0){timerText=addLeadingZero(minutes)+"m "+addLeadingZero(seconds)+"s";}else{timerText=addLeadingZero(seconds)+"s";}var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=this.texts[this.clockIndex].querySelectorAll(".kac-singlecountdown-timer")[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var timer=_step2.value;timer.innerHTML=timerText;}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}if(total<=0){this.iterateClockIndex();this.updateTimer();}}},{key:"iterateClockIndex",value:function iterateClockIndex(){this.texts[this.clockIndex].style.display="none";if(++this.clockIndex>=this.scheduleDays.length){// Wenn alle Countdowns abgelaufen sind:
for(var i=0;i<this.scheduleDays.length;i++){// Verschiebe alle Countdowns um eine Woche
this.scheduleDays[i]+=604800000;// i-ter Countdown = 7 * 24 * 60 * 60s
}this.clockIndex=0;}this.texts[this.clockIndex].style.display="block";}}]);return Countdown;}();document.addEventListener('DOMContentLoaded',function(){var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=document.querySelectorAll(".kac-countdown")[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var node=_step3.value;new Countdown(node);}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}},false);
"use strict";var initialScrollOnNavReveal,header,navbar,revealer;var isSearchActive=false;var isSocialActive=false;document.addEventListener('DOMContentLoaded',function(){revealer=document.getElementById("navbar-revealer");header=document.getElementById("top-header");navbar=document.getElementById("top-navbar");// Set whitespace:
document.getElementById("header-whitespace").style.paddingTop=navbar.offsetHeight+"px";window.onresize=function(){document.getElementById("header-whitespace").style.paddingTop=navbar.offsetHeight+"px";};// Add event listeners
window.addEventListener("scroll",scrollShowRevealer,false);revealer.addEventListener('click',revealTopbar);var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=document.querySelectorAll(".top-searchbtn")[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var btn=_step.value;btn.addEventListener('click',slideDownSearch);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=document.querySelectorAll(".top-social")[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _btn=_step2.value;_btn.addEventListener('click',slideDownSocial);}/****************************
     * TOP BAR REVEAL FUNCTIONS *
     ****************************//**
     * Show topbar.
     *
     * Shows topbar and hides revealer for the time being.
     * Listens to scroll to hide the topbar after 100px again.
     */}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}function revealTopbar(){_showTopbar();initialScrollOnNavReveal=window.pageYOffset;window.addEventListener("scroll",hideTopbarAfterScrolling,false);_hideRevealer();window.removeEventListener("scroll",scrollShowRevealer,false);window.removeEventListener("scroll",scrollHideRevealer,false);}function hideTopbarAfterScrolling(){var scrolledPixels=window.pageYOffset-initialScrollOnNavReveal;if(scrolledPixels>100){_hideTopbar();navbar.addEventListener("animationend",hideTopbarAfterAnimation);}else if(initialScrollOnNavReveal==0){_reattachTopbar();}else if(scrolledPixels<0){// User scrolled up
initialScrollOnNavReveal=window.pageYOffset;}}/**
     * Reset the navbar to its former position in the DOM.
     */function hideTopbarAfterAnimation(){_reattachTopbar();_showRevealer();window.addEventListener("scroll",scrollHideRevealer,false);window.removeEventListener("scroll",hideTopbarAfterScrolling,false);navbar.removeEventListener("animationend",hideTopbarAfterAnimation);}function scrollShowRevealer(revealer){if(window.pageYOffset>header.offsetHeight){_showRevealer();window.removeEventListener("scroll",scrollShowRevealer,false);window.addEventListener("scroll",scrollHideRevealer,false);}}/**
     * Hide the revealer if we've almost reached the top.
     */function scrollHideRevealer(revealer){if(window.pageYOffset<header.offsetHeight){if(window.pageYOffset<1){_deactivateRevealer();}else{_hideRevealer();window.addEventListener("scroll",forceHideRevealer,false);}window.removeEventListener("scroll",scrollHideRevealer,false);window.addEventListener("scroll",scrollShowRevealer,false);}}/**
     * "Hard-shutdown" the revealer.
     *
     * On browsers with elastic scrolling (i.e. Safari), the revealer could be
     * visible over the header if scroll position is > 0.
     * If the scroll position reaches near 0, abort running animations
     * and just hide the element.
     */function forceHideRevealer(revealer){if(window.pageYOffset<1){_deactivateRevealer();window.removeEventListener("scroll",forceHideRevealer,false);}}function _showRevealer(){revealer.classList.remove("closed");revealer.classList.add("opened");}function _hideRevealer(){revealer.classList.remove("opened");revealer.classList.add("closed");}function _deactivateRevealer(){revealer.classList.remove("opened");revealer.classList.remove("closed");}function _showTopbar(){navbar.style.position="fixed";navbar.classList.remove("closed");navbar.classList.add("opened");}function _hideTopbar(){navbar.classList.remove("opened");navbar.classList.add("closed");}function _reattachTopbar(){navbar.style.position="";navbar.classList.remove("closed");}/******************************
     * BUTTON SLIDEDOWN FUNCTIONS *
     ******************************/function slideDownSearch(){if(isSearchActive===false){_activateSearch();if(isSocialActive===true){_deactivateSocial();}}else{_deactivateSearch();}}function slideDownSocial(){if(isSocialActive===false){_activateSocial();if(isSearchActive===true){_deactivateSearch();}}else{_deactivateSocial();}}function _activateSearch(){isSearchActive=true;document.querySelector("#top-slidedown input").style.display="inline-block";animateSliding(document.querySelector("#top-slidedown form"));}function _deactivateSearch(){isSearchActive=false;animateSliding(document.querySelector("#top-slidedown form"),true,function(){document.querySelector("#top-slidedown input").style.display="";});}function _activateSocial(){isSocialActive=true;document.querySelector("#slidedown-social").style.display="block";animateSliding(document.querySelector("#slidedown-social"));}function _deactivateSocial(){isSocialActive=false;animateSliding(document.querySelector("#slidedown-social"),true,function(){document.querySelector("#slidedown-social").style.display="";});}function animateSliding(toAnimate){var reverse=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(){};var elapsed,start;var animate=function animate(time){elapsed=time-start;if(elapsed<500){var x=reverse?1-_ease(elapsed/500):_ease(elapsed/500);toAnimate.style.height=Math.round(x*42)+"px";window.requestAnimationFrame(animate);}else{callback();}};window.requestAnimationFrame(function(time){start=time;animate(time);});}/**
     * JS easing function courtesy of gre@github (easing.js, "EaseInOutQuad")
     */function _ease(x){return x<0.5?2*x*x:-1+(4-2*x)*x;}},false);
"use strict";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var SliderController=function(){function SliderController(parentElement){var _this=this;_classCallCheck(this,SliderController);this.slides=this.generateSlides(parentElement);if(this.slides.length>1){(function(){_this.bullets=parentElement.querySelector(".kac-slider-bullets").childNodes;_this.currentSlide=0;_this.timer=null;_this.isAnimating=false;_this.setBullets(_this.currentSlide);var self=_this;parentElement.querySelector(".kac-slider-arrowleft").addEventListener("click",function(){self.forceMoveToSlide(self.stepIndex(false),false);});parentElement.querySelector(".kac-slider-arrowright").addEventListener("click",function(){self.forceMoveToSlide(self.stepIndex(true),true);});var bullets=parentElement.querySelectorAll(".kac-slider-bullets > *");var _loop=function _loop(i){bullets[i].addEventListener("click",function(){self.forceMoveToSlide(i,self.determineDirection(i));});};for(var i=0;i<bullets.length;i++){_loop(i);}_this.startSlider();})();}this.initialAnimation();}_createClass(SliderController,[{key:"generateSlides",value:function generateSlides(parentElement){var array=[];var mainElements=parentElement.querySelectorAll(".kac-slider-slide");var bgs=parentElement.querySelectorAll(".kac-slide-bg");// Every slide has a slide-bg and its content (in slider-slide), so the numbers are equal.
for(var i=0;i<mainElements.length;i++){var contentContainer=mainElements[i].querySelector(".kac-slide-content");var content=Array.from(contentContainer.querySelectorAll(".kac-slide-content-inner > *"));array.push({contents:[contentContainer].concat(content),mainElement:mainElements[i],bg:bgs[i]});}return array;}// ASSERTION: The first (or whatever current) slide is animated in using a different animation,
// e.g. by scrolling in the chapter or by letting the content fade in.
// Also, the bullets are set within the constructor. So this is just starting the timer.
},{key:"startSlider",value:function startSlider(){var self=this;this.timer=setInterval(function(){self.moveToNextSlide(self.stepIndex(true),true);},8000);}},{key:"stopSlider",value:function stopSlider(){clearInterval(this.timer);}},{key:"forceMoveToSlide",value:function forceMoveToSlide(newIndex,forward){if(this.moveToNextSlide(newIndex,forward)){this.stopSlider();this.startSlider();}}},{key:"moveToNextSlide",value:function moveToNextSlide(newIndex,forward){if(!this.isAnimating){this.slideOut(this.currentSlide,forward);this.slideIn(newIndex,forward);var largestInDuration=1000,largestOutDuration=600;// TODO: get actual animation duration
this.setBullets(newIndex);this.currentSlide=newIndex;// set animation state depending on how long the animations took.
this.isAnimating=true;var self=this;setTimeout(function(){self.isAnimating=false;},largestInDuration>largestOutDuration?largestInDuration:largestOutDuration);return true;}return false;}},{key:"setBullets",value:function setBullets(index){for(var i=0;i<this.bullets.length;i++){this.bullets[i].classList.remove("kac-bulletchecked");}this.bullets[index].classList.add("kac-bulletchecked");}},{key:"findMaxDuration",value:function findMaxDuration(queue,forward){var sumDuration=function sumDuration(animation,queue){if("abortable"in animation&&animation.abortable==true){return 0;}var result=animation.duration;if("delay"in animation){result+=animation.delay;}if("staggered"in animation){result+=animation.staggered*(queue.length-1);}return result;};var largestDuration=0;for(var action in queue){var actionDuration=sumDuration("reverse"in this.animations[action]&&forward===false?this.animations[action].reverse:this.animations[action].forward,queue[action]);if(largestDuration<actionDuration){largestDuration=actionDuration;}}return largestDuration;}},{key:"stepIndex",value:function stepIndex(){var forward=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;if(forward==true){return(this.currentSlide+1)%this.slides.length;}var newIndex=this.currentSlide-1;return newIndex<0?this.slides.length-1:newIndex;}},{key:"determineDirection",value:function determineDirection(index){if(index>this.currentSlide){if(index==this.slides.length-1&&this.currentSlide==0){return false;}else{return true;}}else{if(index==0&&this.currentSlide==this.slides.length-1){return true;}else{return false;}}}},{key:"cssAnimate",value:function cssAnimate(elements,options){var name=options.name,duration=options.duration,_options$curve=options.curve,curve=_options$curve===undefined?"cubic-bezier(.6,0,.5,1)":_options$curve,_options$delay=options.delay,delay=_options$delay===undefined?0:_options$delay,_options$staggered=options.staggered,staggered=_options$staggered===undefined?0:_options$staggered;var animateElement=function animateElement(element,name,duration,curve,delay){element.style.animation=name+" "+duration+"ms "+curve+" "+delay+"ms";element.style.animationFillMode="forwards";element.style.animationDirection="normal";element.style.animationPlayState="running";};if(elements instanceof Array){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=elements[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var element=_step.value;animateElement(element,name,duration,curve,delay);delay+=staggered;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}else{animateElement(elements,name,duration,curve,delay);}}},{key:"slideIn",value:function slideIn(index,forward){var currentSlide=this.slides[index];var fadeElements=false;this.cssAnimate(currentSlide.contents,{name:"kac-content-fadein",duration:160,curve:fadeElements==true?"ease-in":"steps(1, end)",staggered:50});this.cssAnimate([currentSlide.mainElement,currentSlide.bg],forward==true?{name:"kac-slider-slidein",duration:600}:{name:"kac-slider-slidein-reverse",duration:600});}},{key:"initialAnimation",value:function initialAnimation(){var currentSlide=this.slides[0];var fadeElements=false;this.cssAnimate(currentSlide.contents,{name:"kac-content-fadein",duration:160,curve:fadeElements==true?"ease-in":"steps(1, end)",staggered:50});this.cssAnimate(currentSlide.mainElement,{name:"kac-slider-slidein",duration:600});}},{key:"slideOut",value:function slideOut(index,forward){var currentSlide=this.slides[index];var fadeElements=false;this.cssAnimate(currentSlide.contents,{name:"kac-fadeout",duration:100,curve:fadeElements==true?"ease-in":"steps(1, end)"// staggered: 65
});this.cssAnimate(currentSlide.bg,{name:"kac-fadeout",duration:600,curve:"steps(1, end)"});this.cssAnimate(currentSlide.mainElement,forward==true?{name:"kac-slider-slideout",duration:600}:{name:"kac-slider-slideout-reverse",duration:600});}}]);return SliderController;}();document.addEventListener('DOMContentLoaded',function(){var foundSlider=document.querySelector(".kac-slider");if(foundSlider!=null){new SliderController(foundSlider);}},false);